var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      attrs: { width: "65%" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("div", [
                  _c(
                    "h6",
                    { staticClass: "d-flex text-uppercase text-primary" },
                    [
                      _c("div", { staticClass: "type-info" }, [
                        _c("span", [_vm._v(_vm._s(_vm.label))])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "cursive" }, [
                    _vm._v(_vm._s(_vm.name))
                  ])
                ])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c("div", { staticClass: "modal-tour-detail" }, [
          _c(
            "div",
            [
              _c("big-carousel", {
                staticClass: "my-3",
                attrs: { images: _vm.images }
              }),
              _vm._v(" "),
              !_vm.hideForm
                ? _c("div", { staticClass: "mb-3" }, [
                    _c("h5", { staticClass: "cursive" }, [
                      _vm._v(
                        "Scegli il giorno di partenza " +
                          _vm._s(_vm.isCamereRequested ? "le camere" : "") +
                          " " +
                          _vm._s(_vm.isVoloRequested ? "e il volo" : "")
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-3 mt-2" },
                        [
                          _c("CustomDatePicker", {
                            attrs: {
                              placeholder: "SCEGLI UNA DATA",
                              disabledDates: _vm.disabledDates
                            },
                            model: {
                              value: _vm.partenza,
                              callback: function($$v) {
                                _vm.partenza = $$v
                              },
                              expression: "partenza"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isCamereRequested
                        ? _c(
                            "div",
                            { staticClass: "col-12 col-md-4 mt-2" },
                            [
                              _c("CamereSelector", {
                                model: {
                                  value: _vm.camere,
                                  callback: function($$v) {
                                    _vm.camere = $$v
                                  },
                                  expression: "camere"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isVoloRequested
                        ? _c(
                            "div",
                            { staticClass: "col-12 col-md-5 mt-2" },
                            [
                              _c("v-select", {
                                staticClass: "form-control",
                                attrs: {
                                  placeholder: "Aereoporto di partenza",
                                  options: _vm.list
                                },
                                model: {
                                  value: _vm.aereoporto,
                                  callback: function($$v) {
                                    _vm.aereoporto = $$v
                                  },
                                  expression: "aereoporto"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-3 mt-2" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary px-4 w-100",
                            attrs: {
                              id: "procediTour",
                              disabled: _vm.isDisabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.onSelectProcedi()
                              }
                            }
                          },
                          [_vm._v("procedi")]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.partenza
                ? _c(
                    "tabs",
                    { staticClass: "mb-3" },
                    [
                      _c("tab", { attrs: { title: "Descrizione" } }, [
                        _c("div", { staticClass: "mb-3" }, [
                          _c("p", {
                            staticClass: "text-justify",
                            domProps: { innerHTML: _vm._s(_vm.description) }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("CustomGoogleMap", {
                              ref: "mainMap",
                              attrs: { markers: _vm.markers, height: "300px" }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "tab",
                        {
                          attrs: { title: "Itinerario" },
                          on: { click: _vm.onClickItinerario }
                        },
                        _vm._l(_vm.dayByDay, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "row no-gutters mb-4 border-bottom"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-12 col-md-4 pr-md-4" },
                                [
                                  _c("small-carousel", {
                                    staticClass: "mb-3",
                                    attrs: { images: item.imagesUrl }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-md-8" }, [
                                _c("div", { staticClass: "mb-2" }, [
                                  item.kilometers
                                    ? _c("h6", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          _vm._s(index + 1) +
                                            "° giorno (" +
                                            _vm._s(item.kilometers) +
                                            ") - " +
                                            _vm._s(item.descriptionTitle)
                                        )
                                      ])
                                    : _c("h6", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          _vm._s(index + 1) +
                                            "° giorno - " +
                                            _vm._s(item.descriptionTitle)
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../../../assets/images/svg/black/icone_durata.svg"),
                                      height: "12px"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("small", [_vm._v(_vm._s(item.date))])
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-justify" }, [
                                  _vm._v(_vm._s(item.description))
                                ]),
                                _vm._v(" "),
                                item.categoryDescriptions.length > 0
                                  ? _c("div", [
                                      item.categoryDescriptions.some(function(
                                        cat
                                      ) {
                                        return cat.hotels.length > 0
                                      })
                                        ? _c(
                                            "table",
                                            {
                                              staticClass: "table",
                                              staticStyle: {
                                                "font-size": "0.75rem"
                                              }
                                            },
                                            [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c("th", [
                                                    _vm._v("Categoria")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [
                                                    _vm._v("Sistemazione")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [
                                                    _vm._v("Trattamento")
                                                  ])
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  item.categoryDescriptions,
                                                  function(cat, index) {
                                                    return _c(
                                                      "tr",
                                                      { key: index },
                                                      [
                                                        _c("td", [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  cat.category
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.hotelNames(
                                                                    cat.hotels
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  cat.treatment
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        : _c(
                                            "table",
                                            {
                                              staticClass: "table",
                                              staticStyle: {
                                                "font-size": "0.75rem"
                                              }
                                            },
                                            [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    { attrs: { width: "50%" } },
                                                    [_vm._v("Categoria")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "th",
                                                    { attrs: { width: "50%" } },
                                                    [_vm._v("Trattamento")]
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  item.categoryDescriptions,
                                                  function(cat, index) {
                                                    return _c(
                                                      "tr",
                                                      { key: index },
                                                      [
                                                        _c("td", [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  cat.category
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  cat.treatment
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("tab", { attrs: { title: "Specifiche" } }, [
                        _c("div", { staticClass: "mb-3" }, [
                          _c("h4", [_vm._v("Dettagli")]),
                          _vm._v(" "),
                          _c("table", { staticClass: "table table-striped" }, [
                            _c("tbody", [
                              _vm.detail.line
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [
                                        _c("b", [
                                          _vm._v("Tipologia di viaggio")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      [
                                        _c("p", { staticClass: "m-0" }, [
                                          _vm._v(_vm._s(_vm.detail.line))
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.language
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Lingua")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      [
                                        _c("p", { staticClass: "m-0" }, [
                                          _vm._v(_vm._s(_vm.detail.language))
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.treatment
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Trattamento")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      [
                                        _c("p", { staticClass: "m-0" }, [
                                          _vm._v(_vm._s(_vm.detail.treatment))
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.meansOfTransportation
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Mezzi di trasporto")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      _vm._l(
                                        _vm.detail.meansOfTransportation,
                                        function(item, index) {
                                          return _c(
                                            "p",
                                            { key: index, staticClass: "m-0" },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(item) +
                                                  "\n                                        "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.peculiarities
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Peculiarità")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      [
                                        _c("p", { staticClass: "m-0" }, [
                                          _vm._v(
                                            _vm._s(_vm.detail.peculiarities)
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.countriesName
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Nazione")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      _vm._l(_vm.detail.countriesName, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "p",
                                          { key: index, staticClass: "m-0" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(item) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.categories
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Categorie")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      _vm._l(_vm.detail.categories, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "p",
                                          { key: index, staticClass: "m-0" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(item) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.guide
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Accompagnatore")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      [
                                        _c("p", { staticClass: "m-0" }, [
                                          _vm._v(_vm._s(_vm.detail.guide))
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.accomodation
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Sistemazione")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      [
                                        _c("p", { staticClass: "m-0" }, [
                                          _vm._v(
                                            _vm._s(_vm.detail.accomodation)
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-3" }, [
                          _c("h4", [_vm._v("Voli")]),
                          _vm._v(" "),
                          _c("table", { staticClass: "table table-striped" }, [
                            _c("tbody", [
                              _c("tr", [
                                _c("td", { staticStyle: { width: "30%" } }, [
                                  _c("b", [_vm._v("Voli inclusi")])
                                ]),
                                _vm._v(" "),
                                _c("td", { staticStyle: { width: "70%" } }, [
                                  _c("p", { staticClass: "m-0" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.detail.flightIncluded ? "si" : "no"
                                      )
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.detail.departure
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Partenza")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      [
                                        _c("p", { staticClass: "m-0" }, [
                                          _vm._v(_vm._s(_vm.detail.departure))
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.departureAirports
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [
                                        _c("b", [
                                          _vm._v("Aereoporti in partenza")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      _vm._l(
                                        _vm.detail.departureAirports,
                                        function(item, index) {
                                          return _c(
                                            "p",
                                            { key: index, staticClass: "m-0" },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(item) +
                                                  "\n                                        "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.detail.airlines
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { width: "30%" } },
                                      [_c("b", [_vm._v("Compagnie aeree")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { width: "70%" } },
                                      _vm._l(_vm.detail.airlines, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "p",
                                          { key: index, staticClass: "m-0" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(item) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-3" }, [
                          _c("h4", [_vm._v("Pacchetto")]),
                          _vm._v(" "),
                          _c("table", { staticClass: "table table-striped" }, [
                            _c("tbody", [
                              _c("tr", [
                                _c("td", { staticStyle: { width: "30%" } }, [
                                  _c("b", [_vm._v("La quota comprende")])
                                ]),
                                _vm._v(" "),
                                _c("td", { staticStyle: { width: "70%" } }, [
                                  _c("p", {
                                    staticClass: "m-0",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.toBrTag(_vm.detail.priceIncludes)
                                      )
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", { staticStyle: { width: "30%" } }, [
                                  _c("b", [_vm._v("La quota non comprende")])
                                ]),
                                _vm._v(" "),
                                _c("td", { staticStyle: { width: "70%" } }, [
                                  _c("p", {
                                    staticClass: "m-0",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.toBrTag(
                                          _vm.detail.priceDoesNotInclude
                                        )
                                      )
                                    }
                                  })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tab", { attrs: { title: "Note" } }, [
                        !_vm.isMobile
                          ? _c(
                              "table",
                              { staticClass: "table table-striped" },
                              [
                                _c(
                                  "tbody",
                                  _vm._l(_vm.notes, function(item, index) {
                                    return _c("tr", { key: index }, [
                                      _c(
                                        "td",
                                        { staticStyle: { width: "30%" } },
                                        [_c("b", [_vm._v(_vm._s(item.title))])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticStyle: { width: "70%" } },
                                        [
                                          _c("p", {
                                            staticClass: "m-0",
                                            domProps: {
                                              innerHTML: _vm._s(item.text)
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  }),
                                  0
                                )
                              ]
                            )
                          : _c(
                              "div",
                              _vm._l(_vm.notes, function(item, index) {
                                return _c("div", { key: index }, [
                                  _c("b", [_vm._v(_vm._s(item.title))]),
                                  _vm._v(" "),
                                  _c("p", {
                                    staticClass: "mb-3 border-top pt-1",
                                    domProps: { innerHTML: _vm._s(item.text) }
                                  })
                                ])
                              }),
                              0
                            )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39f3e246", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f3e246","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/tour-accompagnati/modals/ModalTourDetail.vue
// module id = null
// module chunks = 